import axios from 'axios'
import Vue from 'vue'
import router from './router'
import {
  Toast
} from 'vant';
import {
  Notify
} from 'vant';
import {
  Dialog
} from 'vant';
import global from './assets/js/global'
const crypto = require("crypto");
Vue.use(Notify);
Vue.use(Toast);

function getUuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}

console.log('1111: ', process.env.API_HOST)
const instance = axios.create({
  baseURL: process.env.API_HOST,
  headers: {
    'Content-Type': 'application/json'
  }
});
// 通过instance.defaults重新设置超时时间为2.5s，因为优先级比系统默认高
instance.defaults.timeout = 60000;
// instance.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 添加一个响应拦截器
// 添加一个请求拦截器
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (config.url.indexOf("noLoading") == -1) {
    const toast = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
    });
  }
  try {
    if (global.isApp) {
      // 1，把timestamp+uuid当做签名字符串，使用HmacSHA256算法计算签名，然后进行Base64 encode。
      // 2,把timestamp+uuid和第一步得到的签名值拼接到前面去
      // 3,把结果放到请求头里，Authorization : Bearer2 rBrGIfY1nL0u7KFpQ+VOXSj6q+ye3b/3SPxK03YtaNA=MTY3ODA4NTUxNDY0MEZDNDA4RjhCLTk1OTgtNDhCNi1BNzQwLUI5MDM3QURDWFhYRQ==
      let deviceId = localStorage.getItem('deviceId')
      console.log('接口请求：', deviceId)
      if (deviceId) {
        const timestamp = new Date().getTime()
        let signStr = sign(timestamp.toString(), deviceId)
        config.headers['Authorization'] = 'Bearer2 ' + signStr
        // console.log(deviceId, signStr, config.headers['Authorization'])
      }
    } else {
      let uuid = localStorage.getItem('uuid')
      let token = localStorage.getItem('token')
      // if (!uuid) {
      //   uuid = getUuid()
      // }
      const timestamp = new Date().getTime()
      let signStr = sign(timestamp.toString(), uuid)
      config.headers['Authorization'] = 'Bearer3 ' + signStr
      // config.headers['Terminal'] = 'dy'
      if (token) {
        config.headers['Token'] = 'Bearer3 ' + token
      }
    }
  } catch (error) {
    console.log('try error')
  }
  //   config.data = formdata;
  // }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error);
  return Promise.reject(error);
});

function sign (timestampStr, uuid) {
  console.log('签名：', timestampStr, uuid)
  let secret = "l8c2scudgvf3aavrkuohep4r6a16nj7s"
  let stringToSign = timestampStr + uuid;
  let mac = crypto.createHmac("sha256", secret);
  mac.update(stringToSign);
  let signData = mac.digest();
  let signStr = Buffer.from(signData).toString("base64");
  let stringToSignStr = Buffer.from(stringToSign).toString("base64");
  return signStr + stringToSignStr;
}

instance.interceptors.response.use(function (response) {
  const res = response.data;
  console.log(res)
  let noAuthority = ''
  if (res.code === 401) {
    Toast.clear()
    Dialog.alert({
      title: '提示',
      message: "请退出重新登录"
    }).then(() => {
      router.replace({
        path: '/login'
      });
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo')
    });
    return Promise.reject(res);
  }
  if (res.code === 405) {
    router.replace({
      path: '/subscribe'
    });
    setTimeout(() => {
      Toast({
        duration: 5000,
        message: res.message,
        position: 'bottom'
      });
    })
    return Promise.reject(res);
  }
  if (res.code !== 401 && res.code !== 405 && res.code !== 200 && res.message) {
    Toast({
      duration: 3000,
      message: res.message,
      position: 'bottom'
    })
    return Promise.reject(res);
  }
  setTimeout(() => {
    Toast.clear();
  }, 1000)
  return Promise.resolve(res);
}, function (error) {
  if (error.message.includes('timeout of 60000ms exceeded')) {
    return Promise.reject({
      message: '请求超时!'
    });
  }
  // Do something with response error
  setTimeout(() => {
    Toast.clear();
  }, 1000)
  if (error.response.data.code === 401) {
    Dialog.alert({
      title: '提示',
      message: "请退出重新登录"
    }).then(() => {
      router.replace({
        path: '/login'
      });
      if (global.isApp) {
        $api.rmStorage('token');
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo')
      }
    });
  }
  // Toast.fail('请求超时！');
  return Promise.reject(error);
});

export default instance


// WEBPACK FOOTER //
// ./src/common.js